"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchParamsToQueryString = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _queryString = require("query-string");
var _excluded = ["size", "page"];
/* eslint-disable import/prefer-default-export */
var searchParamsToQueryString = exports.searchParamsToQueryString = function searchParamsToQueryString(_ref) {
  var size = _ref.size,
    page = _ref.page,
    params = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return "?".concat((0, _queryString.stringify)((0, _extends2.default)({}, params, {
    limit: size,
    page: page + 1
  })));
};